module.exports = __webpack_public_path__ + "media/assets/images/blog/short-41cc4180d6d7e38a7e3e791a8d29b101.jpg";